import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "htmlFor", "required"];
import { forwardRef } from 'react';
import { filterProps } from '../../../utils';
import { useMapStylePropsToCSS } from '../../../hooks/useMapStylePropsToCSS';
import { useFieldsetContext } from './FieldsetContext';
import styled from 'styled-components';
import { Text } from '../../../components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledLabel = styled.label.withConfig({
  displayName: "FormLabel__StyledLabel",
  componentId: "sc-1jca33y-0"
})(({
  $cssStyles,
  $required,
  theme: _theme
}) => {
  const theme = _theme;
  return Object.assign({
    display: 'inline-block',
    verticalAlign: 'middle',
    paddingTop: theme.space['100'],
    paddingBottom: theme.space['100'],
    paddingRight: theme.space['300'],
    '&[for]': {
      cursor: 'default'
    }
  }, $cssStyles, $required && {
    '& > p::after': {
      content: '"\\00a0*"'
    }
  });
});
export const FormLabel = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      htmlFor,
      required = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    size
  } = useFieldsetContext();
  const {
    domProps,
    styleProps
  } = filterProps(rest, {
    labelable: true
  });
  const cssStyles = useMapStylePropsToCSS(styleProps);
  return /*#__PURE__*/_jsx(StyledLabel, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    $required: required,
    htmlFor: htmlFor,
    ref: ref,
    children: /*#__PURE__*/_jsx(Text, {
      typography: size === 'small' ? 'heading-25' : 'heading-50',
      children: children
    })
  }));
});